import {Action} from "redux";
import {
    GetEntryNumOrderProjectListByCustomerRequest,
    GetProjectListByCustomerRequest,
    SearchProjectListByCustomerRequest,
} from "../request/project_request";
import {
    GetProjectListByCustomerResponse,
    SearchProjectListByCustomerResponse,
    GetProjectCountByCustomerResponse, GetEntryNumOrderProjectListByCustomerResponse,
} from "../response/project_response";

export enum CustomerProjectListActionType {
    REQUEST_GET_ENTRY_NUM_ORDER_PROJECT_LIST = "CUSTOMER_PROJECT_REQUEST_GET_ENTRY_NUM_ORDER_PROJECT_LIST",
    CALLBACK_GET_ENTRY_NUM_ORDER_PROJECT_LIST = "CUSTOMER_PROJECT_CALLBACK_GET_ENTRY_NUM_ORDER_PROJECT_LIST",

    REQUEST_GET_PROJECT_LIST = "CUSTOMER_PROJECT_REQUEST_GET_PROJECT_LIST",
    CALLBACK_GET_PROJECT_LIST = "CUSTOMER_PROJECT_CALLBACK_GET_PROJECT_LIST",
    REQUEST_SEARCH_PROJECT_LIST = "CUSTOMER_PROJECT_REQUEST_SEARCH_PROJECT_LIST",
    CALLBACK_SEARCH_PROJECT_LIST = "CUSTOMER_PROJECT_CALLBACK_SEARCH_PROJECT_LIST",

    // ToDo: 削除保留）TotalCountsの取得時のBackendコストを抑えるために、分離したがPager機能との整合性が複雑になるためREQUEST_GET_PROJECT_LIST時に実行されるように変更した
    // ToDo: REQUEST_GET_PROJECT_COUNTは利用していないが、CALLBACK_GET_PROJECT_COUNTは利用している（最終的にCALLBACK_GET_PROJECT_LISTに統合するかなどを検討する）
    REQUEST_GET_PROJECT_COUNT = "CUSTOMER_PROJECT_REQUEST_GET_PROJECT_COUNT",
    CALLBACK_GET_PROJECT_COUNT = "CUSTOMER_PROJECT_CALLBACK_GET_PROJECT_COUNT",

}

export interface IRequestGetEntryNumOrderProjectListAction extends Action {
    type: CustomerProjectListActionType.REQUEST_GET_ENTRY_NUM_ORDER_PROJECT_LIST;
    item: GetEntryNumOrderProjectListByCustomerRequest;
}

export interface ICallbackGetEntryNumOrderProjectListAction extends Action {
    type: CustomerProjectListActionType.CALLBACK_GET_ENTRY_NUM_ORDER_PROJECT_LIST;
    isSuccess: boolean;
    item?: GetEntryNumOrderProjectListByCustomerResponse;
}

export interface IRequestGetProjectListAction extends Action {
    type: CustomerProjectListActionType.REQUEST_GET_PROJECT_LIST;
    item: GetProjectListByCustomerRequest;
}

export interface ICallbackGetProjectListAction extends Action {
    type: CustomerProjectListActionType.CALLBACK_GET_PROJECT_LIST;
    isSuccess: boolean;
    item?: GetProjectListByCustomerResponse;
}

export interface IRequestSearchProjectListAction extends Action {
    type: CustomerProjectListActionType.REQUEST_SEARCH_PROJECT_LIST;
    item: SearchProjectListByCustomerRequest;
}

export interface ICallbackSearchProjectListAction extends Action {
    type: CustomerProjectListActionType.CALLBACK_SEARCH_PROJECT_LIST;
    isSuccess: boolean;
    item?: SearchProjectListByCustomerResponse;
}

export interface IRequestGetProjectCountAction extends Action {
    type: CustomerProjectListActionType.REQUEST_GET_PROJECT_COUNT;
}

export interface ICallbackGetProjectCountAction extends Action {
    type: CustomerProjectListActionType.CALLBACK_GET_PROJECT_COUNT;
    isSuccess: boolean;
    item?: GetProjectCountByCustomerResponse;
}

export type CustomerProjectListAction =
    IRequestGetEntryNumOrderProjectListAction |
    ICallbackGetEntryNumOrderProjectListAction |
    IRequestGetProjectListAction |
    ICallbackGetProjectListAction |
    IRequestSearchProjectListAction |
    ICallbackSearchProjectListAction |
    IRequestGetProjectCountAction |
    ICallbackGetProjectCountAction
    ;

export interface ICustomerProjectListActionCreator {
    requestGetEntryNumOrderProjectListAction(
        item: GetEntryNumOrderProjectListByCustomerRequest
    ): IRequestGetEntryNumOrderProjectListAction;

    callbackGetEntryNumOrderProjectListAction(
        isSuccess: boolean,
        item?: GetEntryNumOrderProjectListByCustomerResponse,
    ): ICallbackGetEntryNumOrderProjectListAction;

    requestGetProjectListAction(
        item: GetProjectListByCustomerRequest
    ): IRequestGetProjectListAction;

    callbackGetProjectListAction(
        isSuccess: boolean,
        item?: GetProjectListByCustomerResponse,
    ): ICallbackGetProjectListAction;

    requestSearchProjectListAction(
        item: SearchProjectListByCustomerRequest,
    ): IRequestSearchProjectListAction;

    callbackSearchProjectListAction(
        isSuccess: boolean,
        item?: SearchProjectListByCustomerResponse,
    ): ICallbackSearchProjectListAction;

    requestGetProjectCountAction(): IRequestGetProjectCountAction;

    callbackGetProjectCountAction(
        isSuccess: boolean,
        item?: GetProjectCountByCustomerResponse,
    ): ICallbackGetProjectCountAction;

}

class ActionCreator implements ICustomerProjectListActionCreator {
    public requestGetEntryNumOrderProjectListAction = (
        item: GetEntryNumOrderProjectListByCustomerRequest
    ): IRequestGetEntryNumOrderProjectListAction => {
        return {
            type: CustomerProjectListActionType.REQUEST_GET_ENTRY_NUM_ORDER_PROJECT_LIST,
            item,
        };
    };

    public callbackGetEntryNumOrderProjectListAction = (
        isSuccess: boolean,
        item?: GetEntryNumOrderProjectListByCustomerResponse,
    ): ICallbackGetEntryNumOrderProjectListAction => {
        return {
            type: CustomerProjectListActionType.CALLBACK_GET_ENTRY_NUM_ORDER_PROJECT_LIST,
            isSuccess,
            item,
        };
    };

    public requestGetProjectListAction = (
        item: GetProjectListByCustomerRequest
    ): IRequestGetProjectListAction => {
        return {
            type: CustomerProjectListActionType.REQUEST_GET_PROJECT_LIST,
            item,
        };
    };

    public callbackGetProjectListAction = (
        isSuccess: boolean,
        item?: GetProjectListByCustomerResponse,
    ): ICallbackGetProjectListAction => {
        return {
            type: CustomerProjectListActionType.CALLBACK_GET_PROJECT_LIST,
            isSuccess,
            item,
        };
    };

    public requestSearchProjectListAction = (
        item: SearchProjectListByCustomerRequest,
    ): IRequestSearchProjectListAction => {
        return {
            type: CustomerProjectListActionType.REQUEST_SEARCH_PROJECT_LIST,
            item,
        };
    };

    public callbackSearchProjectListAction = (
        isSuccess: boolean,
        item?:SearchProjectListByCustomerResponse,
    ): ICallbackSearchProjectListAction => {
        return {
            type: CustomerProjectListActionType.CALLBACK_SEARCH_PROJECT_LIST,
            isSuccess,
            item,
        };
    };

    public requestGetProjectCountAction = (): IRequestGetProjectCountAction => {
        return {
            type: CustomerProjectListActionType.REQUEST_GET_PROJECT_COUNT,
        };
    };

    public callbackGetProjectCountAction = (
        isSuccess: boolean,
        item?: GetProjectCountByCustomerResponse,
    ): ICallbackGetProjectCountAction => {
        return {
            type: CustomerProjectListActionType.CALLBACK_GET_PROJECT_COUNT,
            isSuccess,
            item,
        };
    };

}

export const createCustomerProjectListActionCreator = (): ICustomerProjectListActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/customer_projects_action.ts